import React from "react";
import { Divider, Flex, Text } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { TextInput, NumberInput } from "components";
import { useCurrentCase, useParams } from "duck";
import { ToothEndodonticsEnum } from "requests";
import { FormValues } from "../../duck";
import { getRoots } from "./duck";

const RootCanal: React.FC = () => {
  const { watch } = useFormContext<FormValues>();
  const endodonticsValues = watch("endodontics");

  const species = useCurrentCase(
    medCase => medCase.data.client.patient.species || null
  );
  const { toothNumber } = useParams();
  const roots = getRoots(species, +toothNumber);

  if (
    !endodonticsValues.includes(ToothEndodonticsEnum.StandardRootCanal) &&
    !endodonticsValues.includes(ToothEndodonticsEnum.SurgicalRootCanal)
  ) {
    return null;
  }

  return (
    <Flex direction="column" gap={6}>
      <Text fontWeight="semibold" color="gray.600">
        Root Canal info
      </Text>
      <TextInput name="obturation" label="Obturation" />

      <Flex wrap="wrap" gap={4}>
        <Flex flex={1} direction="column" gap={4}>
          {roots.map((root, i) => (
            <Flex align="center" gap={4} key={root}>
              <NumberInput
                label="Working length"
                labelHidden={i > 0}
                placeholder="-- mm"
                name={`${root}WorkingLength`}
                inputLayoutProps={{ maxW: 32 }}
                inputFieldProps={{
                  pr: 4,
                  textAlign: "center",
                  _placeholder: {
                    textAlign: "center"
                  }
                }}
              />
              <Text mt={i === 0 ? 8 : 0} color="gray.400">
                {roots.length === 1 ? "mm" : `mm ${root}`}
              </Text>
            </Flex>
          ))}
        </Flex>

        <Flex flex={1} direction="column" gap={4}>
          {roots.map((root, i) => (
            <Flex align="center" gap={4} key={root}>
              <NumberInput
                label="MAR/File"
                labelHidden={i > 0}
                placeholder="--"
                name={`${root}MarFile`}
                inputLayoutProps={{ maxW: 32 }}
                inputFieldProps={{
                  pr: 4,
                  textAlign: "center",
                  _placeholder: {
                    textAlign: "center"
                  }
                }}
              />
              <Text mt={i === 0 ? 8 : 0} color="gray.400">
                {roots.length === 1 ? "ISO" : `ISO ${root}`}
              </Text>
            </Flex>
          ))}
        </Flex>
      </Flex>

      <TextInput
        type="text-area"
        name="technique"
        label="Technique"
        placeholder="Enter details here"
      />

      <Divider mb={6} h="1px" borderColor="#D0D1D3" />
    </Flex>
  );
};

export default RootCanal;
